<template>
  <div id="app" class="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App'
}
</script>

<!--<style rel="stylesheet/scss" lang="scss" scoped>-->
<style>
  html,body,#app {
    height: 100%;
    padding: 0px;
    background-color:  #f3f3f3;
   }
</style>



// WEBPACK FOOTER //
// src/App.vue